import { render, staticRenderFns } from "./MassageRecord.vue?vue&type=template&id=7cd1fee6&scoped=true"
import script from "./MassageRecord.vue?vue&type=script&lang=js"
export * from "./MassageRecord.vue?vue&type=script&lang=js"
import style0 from "./MassageRecord.vue?vue&type=style&index=0&id=7cd1fee6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd1fee6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cd1fee6')) {
      api.createRecord('7cd1fee6', component.options)
    } else {
      api.reload('7cd1fee6', component.options)
    }
    module.hot.accept("./MassageRecord.vue?vue&type=template&id=7cd1fee6&scoped=true", function () {
      api.rerender('7cd1fee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inspect/MassageRecord.vue"
export default component.exports